export const ALL_PAYMENT_SITUATIONS = [
  "Assinatura Pendente",
  "Programação Pendente",
  "Em aprovação no Fusion",
  "Pagamento Provisionado",
  "Pagamento Concluído",
] as const;

export type PaymentSituation = (typeof ALL_PAYMENT_SITUATIONS)[number];

export type PaymentHistoryEntry = {
  acao: string;
  data: string;
  id?: number;
  arquivoId?: number | null;
};

export type TituloDeduzido = {
  filial?: string;
  numeroTitulo?: string;
  natureza?: string;
  emissao?: string | null;
  vencimento?: string | null;
  valor?: number;
  historico?: string;
  status?: string;
};

export type OutraDeducao = {
  descricao: string;
  valor: number;
};

export type CondicaoPagamentoOption = {
  id: number;
  titulo: string;
  codigo?: string;
  dias?: number;
  selected?: boolean;
  selecionado?: boolean;
};

export type PaymentListItem = {
  id: number;
  idSolicitacao: number;
  idPagamento?: number;
  ano: number;
  cnpj: string;
  sigla: string;
  nomeSindicato: string;
  situacaoPagamento: PaymentSituation;
  solicitacao: number;
  dataAssinaturaSolicitacao: string | null;
  dataEmissao: string | null;
  valorBruto: number | null;
};

export type PaymentDetail = {
  idSolicitacao: number;
  idPagamento?: number;
  idComprovanteDespesas?: number;
  ano: number;
  cnpj: string;
  sigla: string;
  nomeSindicato: string;
  situacaoPagamento: PaymentSituation;
  solicitacao: number;
  valorBrutoApoio: number;
  valorDeducoes: number;
  valorLiquido: number;
  titulosDeduzidos: TituloDeduzido[];
  outrasDeducoes: OutraDeducao[];
  descricao: string;
  dataEmissao: string | null;
  condicaoPagamento: string;
  condicaoPagamentoId?: number;
  condicoesPagamento?: CondicaoPagamentoOption[];
  dataVencimento: string | null;
  numeroPAG: string;
  dataAprovacaoPAG: string | null;
  numeroTitulo: string;
};

export type SortConfig = {
  key: string | null;
  direction: "asc" | "desc" | null;
};
